import { types } from "../../types/types";

const initialState = {
  items: [],
  cargada: false,
  loading: false,
  seleccionado: null,
  error: null,
};

export const feriadosReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.feriadosTraerStart:
          return {
            ...state,
            loading: true,
            error: null,
            cargada: false,
          };
        case types.feriadosTraerSuccess:
          return {
            ...state,
            loading: false,
            items: action.payload,
            seleccionado: null,
            cargada: true,
          };
        case types.feriadosTraerError:
          return {
            ...state,
            loading: false,
            error: action.payload,
            items: [],
            cargada: false,
          };
        case types.feriadosLimpiar:
          return {
            loading: false,
            items: [],
            cargada: false,
          };
        case types.feriadosModificar:
          return {
            ...state,
            loading: false,
            items: state.items.map( item => item.id === action.payload.id
              ? {...action.payload} 
              : item
            ),
            cargada: true,
          };  
        case types.feriadosEliminar:
          return {
            ...state,
            loading: false,
            items: state.items.filter( item => item.idFeriado !== action.payload ),
            cargada: true,
          };
        case types.feriadosSeleccionar:
          return {
            ...state,
            loading: false,
            seleccionado: action.payload,
            cargada: true,
          };
        case types.feriadosSetCentrosFeriados:
          return {
            ...state,
            loading: false,
            seleccionado: {...state.seleccionado, feriadosCentros: action.payload},
            cargada: true,
          };
        default:
          return state;
      }
    };
    